/** Ícones do painel: um traço só, 1.75, desenhados (nunca emoji). */

const PATHS: Record<string, React.ReactNode> = {
  gauge: (
    <>
      <path d="M4 16a8 8 0 1 1 16 0" />
      <path d="M12 16l4-5" />
      <circle cx="12" cy="16" r="1.5" fill="currentColor" />
      <path d="M3 20h18" />
    </>
  ),
  rows: (
    <>
      <path d="M4 6h16M4 12h16M4 18h16" />
      <path d="M8 4v16" opacity=".5" />
    </>
  ),
  plus: <path d="M12 5v14M5 12h14" strokeWidth="2.25" />,
  cards: (
    <>
      <rect x="3" y="6" width="18" height="12" rx="2" />
      <path d="M3 10h18" />
      <path d="M7 15h3" />
    </>
  ),
  plan: (
    <>
      <rect x="3" y="5" width="18" height="16" rx="2" />
      <path d="M3 10h18M8 3v4M16 3v4" />
      <path d="M8 15l2.5 2.5L16 12" />
    </>
  ),
  sun: (
    <>
      <circle cx="12" cy="12" r="4" />
      <path d="M12 2v2M12 20v2M2 12h2M20 12h2M4.9 4.9l1.4 1.4M17.7 17.7l1.4 1.4M4.9 19.1l1.4-1.4M17.7 6.3l1.4-1.4" />
    </>
  ),
  moon: <path d="M20 14.5A8 8 0 0 1 9.5 4a8 8 0 1 0 10.5 10.5z" />,
  chevronLeft: <path d="M15 6l-6 6 6 6" strokeWidth="2" />,
  chevronRight: <path d="M9 6l6 6-6 6" strokeWidth="2" />,
  x: <path d="M6 6l12 12M18 6L6 18" strokeWidth="2" />,
  check: <path d="M5 12.5l4.5 4.5L19 7.5" strokeWidth="2.25" />,
  wave: <path d="M6 9a8 8 0 0 1 0 6M9.5 7a12 12 0 0 1 0 10M13 5a16 16 0 0 1 0 14" />,
  switch: (
    <>
      <rect x="3" y="8" width="18" height="8" rx="4" />
      <circle cx="16" cy="12" r="2.5" fill="currentColor" />
    </>
  ),
  pen: (
    <>
      <path d="M4 20l4-1 10-10-3-3L5 16l-1 4z" />
      <path d="M13 7l3 3" />
    </>
  ),
  settings: (
    <>
      <circle cx="12" cy="12" r="3.2" />
      <path d="M19.4 15a1.7 1.7 0 0 0 .34 1.87l.06.06a2 2 0 1 1-2.83 2.83l-.06-.06a1.7 1.7 0 0 0-1.87-.34 1.7 1.7 0 0 0-1.03 1.56V21a2 2 0 1 1-4 0v-.09A1.7 1.7 0 0 0 8.9 19.3a1.7 1.7 0 0 0-1.87.34l-.06.06a2 2 0 1 1-2.83-2.83l.06-.06A1.7 1.7 0 0 0 4.6 15a1.7 1.7 0 0 0-1.56-1.03H3a2 2 0 1 1 0-4h.09A1.7 1.7 0 0 0 4.7 8.9a1.7 1.7 0 0 0-.34-1.87l-.06-.06a2 2 0 1 1 2.83-2.83l.06.06A1.7 1.7 0 0 0 9 4.6a1.7 1.7 0 0 0 1.03-1.56V3a2 2 0 1 1 4 0v.09A1.7 1.7 0 0 0 15.1 4.7a1.7 1.7 0 0 0 1.87-.34l.06-.06a2 2 0 1 1 2.83 2.83l-.06.06A1.7 1.7 0 0 0 19.4 9v.09a1.7 1.7 0 0 0 1.56 1.03H21a2 2 0 1 1 0 4h-.09A1.7 1.7 0 0 0 19.4 15z" />
    </>
  ),
  users: (
    <>
      <circle cx="9" cy="8" r="3" />
      <path d="M3 20a6 6 0 0 1 12 0" />
      <path d="M16 5.5a3 3 0 0 1 0 5M17 20a6 6 0 0 0-2-4.5" opacity=".6" />
    </>
  ),
  out: <path d="M12 4v12m0 0l-4.5-4.5M12 16l4.5-4.5M5 20h14" />,
  tags: (
    <>
      <path d="M12.4 3H5.5A2.5 2.5 0 0 0 3 5.5v6.9c0 .66.26 1.3.73 1.77l6.6 6.6a2.5 2.5 0 0 0 3.54 0l6.9-6.9a2.5 2.5 0 0 0 0-3.54l-6.6-6.6A2.5 2.5 0 0 0 12.4 3z" />
      <circle cx="8" cy="8" r="1.6" />
    </>
  ),
  trash: (
    <>
      <path d="M4 7h16M9.5 7V5.2a1.2 1.2 0 0 1 1.2-1.2h2.6a1.2 1.2 0 0 1 1.2 1.2V7" />
      <path d="M6.5 7l.9 12.1a1.2 1.2 0 0 0 1.2 1.1h6.8a1.2 1.2 0 0 0 1.2-1.1L17.5 7" />
      <path d="M10.5 11v5.5M13.5 11v5.5" opacity=".6" />
    </>
  ),
};

/** Chip do cartão: base dourada com pads de contato no mesmo traço dos ícones. */
export function ChipIcon() {
  return (
    <svg className="chipsvg" viewBox="0 0 40 30" aria-hidden="true">
      <defs>
        <linearGradient id="chip-g" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0" stopColor="#E9CF7E" />
          <stop offset="1" stopColor="#B4862B" />
        </linearGradient>
      </defs>
      <rect
        x="1"
        y="1"
        width="38"
        height="28"
        rx="5"
        fill="url(#chip-g)"
        stroke="rgba(70,45,5,.55)"
        strokeWidth="1"
      />
      <g fill="none" stroke="rgba(70,45,5,.6)" strokeWidth="1.25" strokeLinecap="round">
        <path d="M13 1v9a3 3 0 0 1-3 3H1M13 29v-9a3 3 0 0 0-3-3H1M27 1v9a3 3 0 0 0 3 3h9M27 29v-9a3 3 0 0 1 3-3h9M13 13h14M13 17h14" />
        <rect x="15" y="9" width="10" height="12" rx="2" />
      </g>
    </svg>
  );
}

export type IconName = keyof typeof PATHS;

export function Icon({
  name,
  size,
  className,
}: {
  name: IconName;
  size?: number;
  className?: string;
}) {
  return (
    <svg
      className={className}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.75"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      style={size ? { width: size, height: size } : undefined}
    >
      {PATHS[name]}
    </svg>
  );
}
